import Api from 'api'

const config = {
  baseURL: '/api/app/v1/partner-program',
}
const api = new Api(config)

api.fetchAdNetworksTypes = (props) => api.get('/adnetworks-types', props)

api.calculateAwards = (props) => api.post('/calculate-awards', props)

export default api
